import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import ShopingProductCard from "./shopingProductCard";
import productCardIni from "../../../cookieStorage/productCardIni";

function ShopingCard() {

    const limit = 5;              // ← ό,τι θες (από API αύριο)
    const [qty1, setQty1] = useState(1);

    const navigate = useNavigate();

    const inc = () => setQty1(q => Math.min(limit, q + 1));
    const dec = () => setQty1(q => Math.max(0, q - 1));
    const [shopingCardList,setshopingCardList] =useState(()=>(productCardIni()));
    const handleDelete = (id) => {
        setshopingCardList(prev => prev.filter(item => item.id !== id));
    };
    const totalPrice = shopingCardList.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
    );

    /*useEffect(() => {

    },[])*/
    const handleQuantityChange = (id, newQuantity) => {
        setshopingCardList(prev => {
            const updated = prev.map(item =>
                item.id === id
                    ? { ...item, quantity: newQuantity }
                    : item
            );

            localStorage.setItem("productCard", JSON.stringify(updated));
            return updated;
        });
    };

    return (
        <div >
            <section id="page-header" className="bg-white py-12 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="flex items-center space-x-3 text-sm text-gray-600 mb-4">
                        <a href="#" className="hover:text-brand-green transition-colors">Home</a>
                        <i className="fas fa-chevron-right text-xs"></i>
                        <span className="text-brand-green font-medium">Shopping Cart</span>
                    </div>
                    <h1 className="text-4xl font-serif font-bold text-gray-800">Your Shopping Cart</h1>
                    <p className="text-lg text-gray-600 mt-2">Review your items before checkout</p>
                </div>
            </section>

            <section id="cart-content" className="py-16 bg-cream font-print">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        <div id="cart-items" className="lg:col-span-2">
                            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                                <div className="p-6 border-b border-gray-100">
                                    <h2 className="text-2xl font-serif font-semibold text-gray-800">Cart Items
                                        ({shopingCardList.length})</h2>
                                </div>

                                {
                                    shopingCardList?.map((item, index) => (
                                        //Πρόσεχε: βάλε key={item.id}, όχι key={item.productID} αν στο cart χρησιμοποιείς id
                                        <ShopingProductCard key={item.productID}
                                                            {...{
                                                                name: item.name,
                                                                rating: item.rating,
                                                                price: item.price,
                                                                quantity: item.quantity,
                                                                description: item.description,
                                                                image: item.image,
                                                                id: item.id,
                                                                color: item.color,
                                                                indexn: index
                                                            }
                                        } onDelete={handleDelete}
                                          onQuantityChange={handleQuantityChange}
                                        />
                                    ))
                                }
                            </div>

                            <div id="continue-shopping" className="font-print mt-6" onClick={() => {
                                navigate(`/products`)
                            }}>
                                <a href="#"
                                   className="inline-flex items-center text-custom-green hover:text-dark-green font-medium transition-colors group">
                                    <i className="fas fa-arrow-left mr-2 group-hover:-translate-x-1 transition-transform"></i>
                                    Continue Shopping
                                </a>
                            </div>

                        </div>

                        <div id="order-summary" className="lg:col-span-1">
                            <div className="bg-white rounded-xl shadow-sm p-6 sticky top-24">
                                <h2 className="text-2xl font-serif font-semibold text-gray-800 mb-6">Order Summary</h2>

                                <div className="space-y-4 mb-6">
                                    <div className="flex justify-between text-gray-600">
                                        <span>Subtotal</span>
                                        <span className="font-medium">€{totalPrice-(totalPrice*0.24)}</span>
                                    </div>
                                    <div className="flex justify-between text-gray-600">
                                        <span>Shipping</span>
                                        <span className="font-medium">€8.00</span>
                                    </div>
                                    <div className="flex justify-between text-gray-600">
                                        <span>Tax (24%)</span>
                                        <span className="font-medium">€{totalPrice*0.24}</span>
                                    </div>
                                </div>

                                <div className="border-t border-gray-200 pt-4 mb-6">
                                    <div className="flex justify-between text-xl font-bold text-gray-800">
                                        <span>Total</span>
                                        <span className="text-custom-green">€{totalPrice}</span>
                                    </div>
                                </div>

                                <div id="promo-code" className="mb-6">
                                   {/* <label className="block text-sm font-medium text-gray-700 mb-2">Promo Code</label>
                                    <div className="flex space-x-2">
                                        <input type="text" placeholder="Enter code"
                                               className="flex-grow px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-brand-green"/>
                                        <button
                                            className="px-6 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition-colors">
                                            Apply
                                        </button>
                                    </div>*/}
                                </div>

                                <button onClick={()=>{navigate(`/order`);}}
                                    className="w-full bg-custom-green hover:bg-dark-green text-white py-4 rounded-lg font-semibold text-lg transition-colors duration-300 mb-4">
                                    Proceed to Checkout
                                </button>

                                <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
                                    <i className="fas fa-lock"></i>
                                    <span>Secure Checkout</span>
                                </div>

                                <div className="mt-6 pt-6 border-t border-gray-200">
                                    <h3 className="font-semibold text-gray-800 mb-3">We Accept</h3>
                                    <div className="flex items-center space-x-3">
                                        <i className="fab fa-cc-visa text-3xl text-gray-400"></i>
                                        <i className="fab fa-cc-mastercard text-3xl text-gray-400"></i>
                                        <i className="fab fa-cc-amex text-3xl text-gray-400"></i>
                                        <i className="fab fa-cc-paypal text-3xl text-gray-400"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}


export default ShopingCard;